<template>
  <div :class="{'mt-3':!showRemoveIcon}">
    <validation-observer
      ref="form"
    >
      <div
        v-for="(btn,ind) in buttons"
        :key="ind"
        class="fieldset"
      >
        <legend>{{ $t('reply.form.button-number',{number:ind+1}) }}</legend>
        <div
          class="row mt-2 button-container"
          style="position: relative"
        >
          <div class="col-md-4">
            <ok-text-input
              v-model="btn.title"
              is-required
              :label="getReplyTrans('button_title')"
            >
              <template #footer>
                <p
                  v-if="btn.title"
                  class="float-right mb-0"
                >
                  {{ btn.title.length +'/20' }}
                </p>
              </template>
            </ok-text-input>
          </div>
          <div class="col-md-4">
            <ok-select
              v-model="btn.type"
              :options="translatedOptions"
              is-required
              :label="getReplyTrans('button_type')"
            />
          </div>
          <div class="col-md-4">
            <ok-text-input
              v-if="btn.type==='web_url'"
              v-model="btn.payload"
              is-required
              rules="url"
              dir="ltr"
              :label="getReplyTrans('web_url')"
            />
            <ok-text-input
              v-if="btn.type==='phone_number' || btn.type==='whatsapp'"
              v-model="btn.payload"
              dir="ltr"
              is-required
              rules="phone"
              :label="getReplyTrans('phone_number')"
            />
            <general-templates-select
              v-if="btn.type==='webview'"
              v-model="btn.payload"
              :options="webviewTemplates"
              label="اختر النموذج"
              is-required
            />
          </div>

          <b-button
            v-if="ind>0 || (ind===0 && showRemoveIcon)"
            class="remove-button btn-icon"
            variant="danger"
            size="sm"
            @click="remove(ind)"
          >
            <FeatherIcon icon="TrashIcon" />
          </b-button>
        </div>
      </div>
    </validation-observer>
    <button
      v-if="buttons && buttons.length<3"
      class="btn btn-sm btn-info"
      :class="{'mt-2':(buttons.length===0)}"
      @click="addMoreButton"
    >
      <i class="fa fa-plus" />
      <template v-if="buttons.length===0">
        {{ getReplyTrans('add_button') }}
      </template>
      <template v-else>
        {{ getReplyTrans('add_more_button') }}
      </template>

    </button>
  </div>
</template>

<script>
import OkTextInput from '@/@bya3/components/inputs/OkTextInput'
import { BButton } from 'bootstrap-vue'
import { forEach } from 'lodash'
import OkSelect from '@/@bya3/components/inputs/OkSelect'
import { ValidationObserver } from 'vee-validate'
import GeneralTemplatesSelect from '@/@bya3/components/inputs/GeneralTemplatesSelect'
import { mapGetters } from 'vuex'

export default {
  name: 'ButtonsInput',
  components: {
    GeneralTemplatesSelect,
    OkSelect,
    OkTextInput,
    BButton,
    ValidationObserver,
  },
  props: {
    componentButtons: {
      type: Array,
      default: () => [],
    },
    showRemoveIcon: {
      type: Boolean,
      default: false,
    },
    isFacebook: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      options: [
        'web_url',
        'phone_number',
        'whatsapp',
      ],
      buttons: [],
      translatedOptions: [],
    }
  },
  computed: {
    ...mapGetters({
      webviewEnabled: 'pages/webviewEnabled',
      webviewTemplates: 'webview/templates',
      isInstagram: 'auth/isInstagram',
    }),
  },
  watch: {
    buttons: {
      deep: true,
      handler() {
        this.$emit('input', this.buttons)
      },
    },
  },
  mounted() {
    this.setOptions()
    this.$nextTick(() => { this.buttons = this.componentButtons })
  },
  methods: {
    getReplyTrans(string) {
      return this.$t(`reply.form.${string}`)
    },
    setOptions() {
      if (this.webviewEnabled && this.isFacebook) this.options.push('webview')
      const options = (!this.isFacebook || this.isInstagram) ? ['web_url', 'whatsapp'] : this.options
      forEach(options, option => {
        this.translatedOptions.push({ label: this.getReplyTrans(option), value: option })
      })
    },
    addMoreButton() {
      this.buttons.push({
        title: '',
        type: 'web_url',
        payload: '',
      })
    },
    remove(index) {
      this.buttons.splice(index, 1)
    },
  },
}
</script>
